import React, { useEffect } from 'react';

import { constants } from 'helpers/constants';
import { physicalDeliveryStore } from 'v2/store/PhysicalDelivery';

import Wizard from './components/Wizard';
import { useWizardState } from './contexts/WizardStateContext';
import InfoProduct from './InfoProduct';
import PhysicalProduct from './PhysicalProduct';
import ServiceProduct from './ServiceProduct';

function NewProduct() {
  const { selected, resetProduct, resetWizard, resetSelected } = useWizardState();

  useEffect(() => {
    const qs = new URLSearchParams(window.location.search).get('type')?.toUpperCase();
    const initialSelected = qs ? (constants[qs as keyof typeof constants] as number) : undefined;
    const initialStep = initialSelected ? 2 : 1;

    try {
      resetProduct();
      resetWizard(initialStep);
      resetSelected(initialSelected);
      physicalDeliveryStore.getState().reset();
    } catch (error) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Wizard>
        {selected === constants.INFO && <InfoProduct />}
        {selected === constants.PHYSICAL && <PhysicalProduct />}
        {selected === constants.SERVICE && <ServiceProduct />}
        {selected === constants.SUBSCRIPTION && <InfoProduct isSubscription />}
      </Wizard>
    </>
  );
}

export default NewProduct;
